import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { Box } from '@ovComponents/1-primative/box/box';
import { Typography } from '@ovComponents/1-primative/typography/typography';
import { Card, CardContent } from '@ovComponents/2-component/card/card';
import { IconButton } from '@ovComponents/2-component/iconButton/iconButton';
import { AumExplorer } from '../homePageWidgets/aumExplorer/aumExplorer';
import { FeesAndRevenue } from '../homePageWidgets/feesAndRevenue';
import { FreeformInput } from '../homePageWidgets/freeformInput';
import { MarketDataTicker } from '../homePageWidgets/marketDataTicker';
import { OpenWorkflows } from '../homePageWidgets/openWorkflows';
import { PendingTransactions } from '../homePageWidgets/pendingTransactions/pendingTransactions';
import { PracticeOverview } from '../homePageWidgets/practiceOverview/practiceOverview';
import { QuickLinks } from '../homePageWidgets/quickLinks';
import { Report } from '../homePageWidgets/report';

type HomePageWidgetProps = {
  type: string;
  i: number;
  onDelete?: (id: number) => void;
  onEdit?: () => void;
  viewOnly?: boolean;
  options: any;
};

export const HomePageWidget = ({
  type,
  i,
  onDelete,
  onEdit,
  viewOnly = false,
  options,
}: HomePageWidgetProps) => {
  const widget = (widgetType: string) => {
    switch (widgetType) {
      case 'FREE_FORM_INPUT':
        return <FreeformInput options={options} />;
      case 'MARKET_DATA_TICKER':
        return <MarketDataTicker options={options} />;
      case 'PRACTICE_OVERVIEW':
        return <PracticeOverview options={options} />;
      case 'QUICK_LINKS':
        return <QuickLinks options={options} />;
      case 'AUM_EXPLORER':
        return <AumExplorer options={options} />;
      case 'FEES_AND_REVENUE':
        return <FeesAndRevenue options={options} />;
      case 'PENDING_TRANSACTIONS':
        return <PendingTransactions options={options} />;
      case 'OPEN_WORKFLOWS':
        return <OpenWorkflows options={options} />;
      case 'REPORT':
        return <Report options={options} />;
      default:
        return (
          <Card sx={{ height: '100%' }}>
            <CardContent
              sx={{ justifyContent: 'space-between', display: 'flex' }}
            >
              <Typography variant='headingXSmall'>{type}</Typography>
            </CardContent>
          </Card>
        );
    }
  };

  return (
    <Box
      height='100%'
      sx={{
        position: 'relative',
        mb: 2,
      }}
    >
      {widget(type)}
      <Box position='absolute' right={0} top={0}>
        {/* Edit button */}
        {!viewOnly && onEdit && (
          <IconButton onClick={() => onEdit()}>
            <EditIcon fontSize='small' />
          </IconButton>
        )}

        {/* Delete button */}
        {!viewOnly && onDelete && (
          <IconButton onClick={() => onDelete(i)}>
            <DeleteIcon fontSize='small' />
          </IconButton>
        )}
      </Box>
    </Box>
  );
};
